import * as Yup from "yup";

export interface SelectOption {
  value: string;
  label: string;
}

export const statusOptions: SelectOption[] = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
  { label: "Repair", value: "REPAIR" },
  { label: "Rental", value: "RENTAL" },
  { label: "Out Of Service", value: "OUT OF SERVICE" }
];

export interface EquipmentDetailModel {
  id: string | null;
  unitNumber: string | null;
  equipmentType: string | null;
  assetDescriptor: string | null;
  make: string | null;
  model: string | null;
  year: string | null;
  vin: string | null;
  licensePlate: string | null;
  registrationDate: string | null;
  dotInspectionDate: string | null;
  domicileTerminal: string | null;
  location: string | null;
  garageCity: string | null;
  garageState: string | null;
  status: string | null;
  disposition: string | null;
  utilizationPercent: string | null;
  dwellTimeDays: string | null;
  leaseType: string | null;
  vendor: string | null;
  productLine: string | null;
  termMonths: string | null;
  annualAllowance: string | null;
  annualRateMeasurement: string | null;
  monthlyRate: string | null;
  size: string | null;
  accessory: string | null;
  serialNumber: string | null;
  inServiceDate: string | null;
  expirationDate: string | null;
  fuelType: string | null;
  registrationDocUrl: string | null;
  dotCertificateUrl: string | null;
  notes: string | null;
}
export interface EquipmentFormModel {
  id: string | null;
  unitNumber: string | null;
  equipmentType: string | null;
  assetDescriptor: string | null;
  make: string | null;
  model: string | null;
  year: string | null;
  vin: string | null;
  licensePlate: string | null;
  registrationDate: string | null;
  dotInspectionDate: string | null;
  domicileTerminal: string | null;
  location: string | null;
  garageCity: string | null;
  garageState: string | null;
  status: string | null;
  disposition: string | null;
  utilizationPercent: string | null;
  dwellTimeDays: string | null;
  leaseType: string | null;
  vendor: string | null;
  productLine: string | null;
  termMonths: string | null;
  annualAllowance: string | null;
  annualRateMeasurement: string | null;
  monthlyRate: string | null;
  size: string | null;
  accessory: string | null;
  serialNumber: string | null;
  inServiceDate: string | null;
  expirationDate: string | null;
  fuelType: string | null;
  registrationDocUrl: string | null;
  dotCertificateUrl: string | null;
  notes: string | null;
}

export const getEquipmentInfoValidation = (): Yup.ObjectSchema<EquipmentFormModel> => {

  return Yup.object().shape({
    unitNumber: Yup.string().required("Unit number is required"),
    equipmentType: Yup.string().required("Type is required"),
    assetDescriptor: Yup.string().nullable(),
    make: Yup.string().nullable(),
    model: Yup.string().nullable(),
    year: Yup.string()
      .nullable()
      .test(
        "year-format",
        "Enter a valid 4-digit year",
        (value) => !value || /^(19|20)\d{2}$/.test(value)
      ),
    vin: Yup.string().nullable(),

    licensePlate: Yup.string().nullable().max(200, "Too long"),
    registrationDate: Yup.string().nullable(),
    dotInspectionDate: Yup.string().nullable(),

    location: Yup.string().required("Terminal is required"),
    status: Yup.string().nullable(),

    leaseType: Yup.string().nullable(),
    vendor: Yup.string().nullable(),

    notes: Yup.string().nullable().max(1000, "Notes cannot exceed 1000 characters"),

  }).defined();
};